import { render, staticRenderFns } from "./cumulative-report-app.vue?vue&type=template&id=2f2a8a0e"
import script from "./cumulative-report-app.vue?vue&type=script&lang=js"
export * from "./cumulative-report-app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports